import { render, staticRenderFns } from "./commentModal.vue?vue&type=template&id=64abc232&scoped=true"
import script from "./commentModal.vue?vue&type=script&lang=js"
export * from "./commentModal.vue?vue&type=script&lang=js"
import style0 from "./commentModal.vue?vue&type=style&index=0&id=64abc232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64abc232",
  null
  
)

export default component.exports